import React, {useState, useEffect} from 'react'

import usePortfolioStore from '../../stores/PortfolioStore';
import DonutChart from '../subcomponents/DonutChart';


import {processPortfolioData} from "../../utils/ProcessPortfolioData"

function PairsPortfolio() {
  const portfolio = usePortfolioStore((state) => state.pairs)
 

  const portfolios = processPortfolioData(portfolio);
  return (
    <div className="donuts_container">
    {Object.keys(portfolios).map(portfolioName => (
      <DonutChart key={portfolioName} data={portfolios[portfolioName]} title={portfolioName}/>
    ))}
</div>
  )
}

export default PairsPortfolio